module.exports = __webpack_public_path__ + "h.no2.1475a3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/h.no2.jpg
// module id = zyJx
// module chunks = 0